<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="250px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-inner-icon="mdi-clock-outline"
        hide-details
        outlined
        readonly
        v-model="formattedDate"
        :label="label"
        :class="inputClass"
        v-on="on"
        v-bind="$attrs"
        @blur="onBlur"
      />
    </template>
    <v-card>
      <v-time-picker v-model="localValue"
                     format="24hr"
                     :allowed-minutes="allowedStep"
                     @click:minute="opened = false"
      ></v-time-picker>
    </v-card>
  </v-menu>
</template>

<script>
import DateUtils from './utils/date-formatter-utils';

export default {
  props: ['value', 'label', 'inputClass'],
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    onSelectDate(data) {
      this.localValue = data;
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    allowedStep: (m) => m % 5 === 0,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    formattedDate() {
      return DateUtils.formatTimeHourMinute(this.localValue);
    },
  },
};
</script>
